<template>
  <div
    class="custom-select"
    :class="(inputWidthHeightClass, borderClass)"
    :tabindex="tabindex"
    @blur="open = false"
  >
    <div
      class="selected"
      :class="[inputWidthHeightClass, isClassOpen, borderClass]"
      @click="open = !open"
    >
      <div
        class="flex-grow whitespace-nowrap"
        :class="[ {'text-center font-bold text-sm sm:text-12': isCenter}, selectedTextColorClass ]"
      >
        {{ selected.name ? selected.name : placeholder }}
      </div>
      <div class="mx-5">
        <arrow-icon :class="{ arrow: open }" />
      </div>
    </div>
    <div class="items" :class="{ selectHide: !open }">
      <div
        v-for="(option, i) of options"
        :key="i"
        :class="borderClass"
        @click="
          selected = option;
          open = false;
          $emit('input', option.value);
        "
      >
        <p
          class="text-subtitle whitespace-nowrap"
          :class="{
            'text-success': option.value === 'success',
            'text-danger': option.value === 'danger',
            'text-warning': option.value === 'warning',
            'text-info': option.value === 'info',
          }"
        >
          {{ option.name }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import ArrowIcon from '@/assets/icons/vue/arrow_down.vue';

export default {
  components: { ArrowIcon },
  props: {
    options: {
      type: Array,
      required: true,
    },
    width: {
      type: String,
      default: 'full',
    },
    height: {
      type: String,
      default: '68',
    },
    radius: {
      type: String,
      default: 'sm',
    },
    default: {
      type: Object,
      default() {
        return {};
      },
      required: false,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    isCenter: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  watch: {
    default() {
      this.selected = this.default;
    },
  },
  computed: {
    inputWidthHeightClass() {
      return `w-${this.width} h-${this.height}`;
    },
    isClassOpen() {
      return { open: this.open };
    },
    borderClass() {
      return {
        rounded: this.radius === 'default',

        'rounded-sm': this.radius === 'sm',
      };
    },
    selectedTextColorClass() {
      const SELECTED_TO_LOWERCASE = this.selected.name?.toLowerCase();
      switch (SELECTED_TO_LOWERCASE) {
        case this.$i18n.t('success').toLowerCase():
          return 'text-success';
        case this.$i18n.t('danger').toLowerCase():
          return 'text-danger';
        case this.$i18n.t('warning').toLowerCase():
          return 'text-warning';
        case this.$i18n.t('info').toLowerCase():
          return 'text-info';
        default:
          return '';
      }
    },
  },
  data() {
    return {
      selected: '',
      open: false,
    };
  },
  mounted() {
    if (this.default) {
      this.selected = this.default;
    } else {
      this.selected = this.options[0];
    }
    this.$emit('input', this.selected.value);
  },
};
</script>

<style scoped>
.custom-select {
  @apply w-full text-left outline-none bg-secondary relative cursor-pointer border
    border-default;
}
.custom-select:is(:lang(fa), :lang(ar)) {
  @apply text-right;
}
.custom-select .selected {
  @apply py-5 px-10 text-18 font-normal flex items-center text-subtitle;
}
.custom-select .items {
  @apply absolute bg-secondary rounded-b z-20 shadow-lg max-h-200
  overflow-y-scroll left-0 right-0 text-subtitle;
}
.custom-select .items div {
  @apply text-subtitle px-10 cursor-pointer py-12;
  user-select: none;
}
.custom-select .items div:hover {
  @apply bg-tertiary;
}
.selectHide {
  @apply hidden;
}
.arrow {
  @apply top-15;
  transform: rotate(-180deg);
}
</style>
